<template>

	<div id="font_purchase">

		<div class="font_purchase-wrap">

			<!--MV-->
			<section class="first">
				<div class="renew2_wrapper">
					<h2>フォント切り替えサービス</h2>
					<div class="renew2_flex">
						<img src="/static/renew2_img/font_purchase_img_fontmv.png" alt="フォント切り替えサービス" class="first-img">
						<div class="first-flexright">
							<div class="first01">
								<p class="first01-title">履歴書の入力欄のフォントを変えることができるサービスです。</p>
								<p class="first01-txt">
									多くのユーザーにリクエストいただいている明朝体とゴシック体にも切り替えることができます。※ヤギプライム登録することで本機能を利用することが可能です。</p>
							</div>
							<div class="font_purchase-cv">
								<button type="button"
						v-if="$firebase.isAuthenticated && !fontPaymented"
						@click="registYagiprime"
									class="el-button cv-btn cv-btn--red cv-btn--radius cv-btn--cubic el-button--default prime_cv-btn">
									<!----><!----><span>月額550円の</span>ヤギプライムで利用する！
								</button>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!--フォントの特徴-->
			<section class="renew2_wrapper second">
				<h3>選べるフォント</h3>
				<div class="center">
					<p>フォントが増えたときも、追加購入不要で使えます！</p>
					<p>※今後のサービス拡大によりフォントが増える可能性があります。</p>
					<img src="/static/renew2_img/font_purchase_img_fontmv.png" alt="選べるフォント一覧" class="fontlist">
				</div>
				<div class="font_purchase-cv">
					<button type="button"
						v-if="$firebase.isAuthenticated && !fontPaymented"
						@click="registYagiprime"
						class="el-button cv-btn cv-btn--red cv-btn--radius cv-btn--cubic el-button--default prime_cv-btn">
						<!----><!---->フォントを変更する
					</button>
				</div>
			</section>

			<!--フォントの使い方-->
			<section class="third">
				<h3>フォント切り替えの方法</h3>
				<p class="center">※ヤギプライムに加入している方の特典としてご利用いただけます。</p>
				<ul class="second01">
					<li class="feature-item">
						<p class="feature-title">① 作成中の画面下の「プレビュー」をクリック！</p>
						<img src="/static/renew_img/font_lp_img/step_01.png" alt="例文付きで簡単にメール送信" class="preview-img">
					</li>
					<li class="feature-item">
						<p class="feature-title">② プレビュー画面の「フォント変更を利用する」ボタンをクリック！</p>
						<img src="/static/renew_img/font_lp_img/step_02.png" alt="プレビュー画面の「フォント変更を利用する」ボタンをクリック！"
							class="preview-img">
					</li>
					<li class="feature-item">
						<p class="feature-title">③ フォントを選択し、「選択したフォントに変更」ボタンをクリック！</p>
						<p>※緑の変更ボタンを押さないと履歴書に反映されません。</p>
						<img src="/static/renew_img/font_lp_img/step_04.png" alt="フォントを選択し、「選択したフォントに変更」ボタンをクリック！"
							class="preview-img">
					</li>
				</ul>
				<div class="font_purchase-cv">
					<p>＼ヤギプライム登録で全てのフォントが使えます！／</p>
					<button type="button"
						v-if="$firebase.isAuthenticated && !fontPaymented"
						@click="registYagiprime"
						class="el-button cv-btn cv-btn--red cv-btn--radius cv-btn--cubic el-button--default prime_cv-btn">
						<!----><!---->フォントを変更する
					</button>
				</div>
			</section>

			<!--よくある質問-->
			<section class="renew2_wrapper sixth">
				<h3>よくある質問</h3>
				<ul class="faqtop3">
					<li class="faqtop3_item">
						<p class="question">ヤギプライムの特典のフォント変更ができません。</p>
						<p class="answer">ブラウザによってフォント変更がすぐ反映されない場合があります。その現象が発生した場合には再読み込みを行うか、アプリを閉じてから再度実行してください。</p>
					</li>
					<li class="faqtop3_item">
						<p class="question">フォントサービスの有効期限はありますか。</p>
						<p class="answer">ヤギプライムを解約するとフォント変更は使用できなくなります。</p>
					</li>
					<li class="faqtop3_item">
						<p class="question">フォントはどこから決済し変更できますか。</p>
						<p class="answer">ヤギプライム会員になると、フォント変更可能です。</p>
					</li>
					<li class="faqtop3_item">
						<p class="question">利用規約を教えてください。</p>
						<p class="answer">利用規約は<a href="/yagiprimeterms">こちら</a>からご確認ください。</p>
					</li>
				</ul>
				<div class="font_purchase-cv">
					<p>＼ヤギプライム登録で全てのフォントが使えます！／</p>
					<button type="button"
						v-if="$firebase.isAuthenticated && !fontPaymented"
						@click="registYagiprime"
						class="el-button cv-btn cv-btn--red cv-btn--radius cv-btn--cubic el-button--default prime_cv-btn">
						<!----><!---->フォントを変更する
					</button>
				</div>
			</section>
		</div>

	</div>
</template>

<style lang="css" src="@/assets/css/font_lp_stylesheet.css"></style>

<style scoped>
	#font_purchase .renew2_wrapper {
		width: 768px;
	}

	#font_purchase a:hover {
		text-decoration: none;
		opacity: 1;
	}

	#font_purchase h2 {
		font-size: 18px;
		color: #004D40;
		text-align: center;
		margin-bottom: 20px;
	}

	#font_purchase h3 {
		font-size: 16px;
		color: #004D40;
		text-align: center;
		margin-bottom: 20px;
	}

	#font_purchase .first {
		background: #FFFFE8;
		padding: 30px 0;
		margin-bottom: 50px;
	}

	#font_purchase .first01 {
		background: #fff;
		padding: 20px;
		border-radius: 10px;
		margin-bottom: 20px;
	}

	#font_purchase .first01-title {
		color: #E95B10;
		font-weight: bold;
		font-size: 16px;
		margin-bottom: 10px;
	}

	#font_purchase .first-img {
		width: 100%;
		max-width: 100%;
	}

	#font_purchase .first-flexright {
		width: 100%;
		margin-top: 20px;
	}

	#font_purchase .first .renew2_flex {
		justify-content: space-between;
	}

	#font_purchase .center {
		text-align: center;
	}

	#font_purchase .fontlist {
		margin: 20px 0;
		width: 300px;
		height: auto;
	}

	#font_purchase .second01 {
		width: 878px;
		max-width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin: 20px auto;
	}

	#font_purchase .feature-item {
		width: calc(100% / 2 - 5px);
		background: #EEF5E8;
		border-radius: 10px;
		margin-bottom: 10px;
	}

	#font_purchase .feature-title {
		background: #004D40;
		color: #fff;
		font-weight: bold;
		border-radius: 10px 10px 0 0;
		padding: 10px;
	}

	#font_purchase .second02 {
		margin-left: 20px;
		text-align: left;
	}

	#font_purchase .second {
		margin-bottom: 50px;
	}

	#font_purchase .third {
		background: #EEF5E8;
		padding: 50px 0;
		margin-bottom: 50px;
	}

	#font_purchase .third.second01 {
		margin-bottom: 0;
	}

	#font_purchase .third .feature-item {
		width: 100%;
		background: #fff;
		padding: 20px;
	}

	#font_purchase .third .feature-title {
		background: none;
		color: #004D40;
		padding: 0;
	}

	#font_purchase .preview-img {
		margin-top: 30px;
	}

	#font_purchase .font_purchase-cv {
		text-align: center;
	}

	#font_purchase .cv-btn {
		position: relative;
		display: inline-block;
		background: #E3165C;
		color: #fff;
		font-size: 18px;
		font-weight: bold;
		width: 300px;
		margin: 0 auto;
		padding: 15px 0;
		border-radius: 10px;
		transition-duration: .4s;
	}

	#font_purchase .cv-btn::before {
		content: '';
		width: 13px;
		height: 13px;
		border: 0;
		border-top: solid 2px #404040;
		border-right: solid 2px #404040;
		transform: rotate(45deg);
		position: absolute;
		top: 0;
		right: 20px;
		bottom: 0;
		margin: auto;
	}

	#font_purchase .cv-btn:hover {
		transform: scale(1.1);
	}

	#font_purchase .first .cv-btn {
		width: 100%;
	}

	#font_purchase .sixth {
		margin-bottom: 50px;
	}

	#font_purchase .faqtop3 {
		margin-bottom: 50px;
	}

	#font_purchase .faqtop3_item {
		margin-bottom: 20px;
	}

	#font_purchase .question {
		position: relative;
		font-weight: 700;
		color: #004d40;
		padding: 0 0 10px 30px;
	}

	#font_purchase .question::before {
		position: absolute;
		content: "Q";
		color: #0f9934;
		font-size: 1.6rem;
		left: 3px;
		top: -10px;
		opacity: 0.5;
	}

	#font_purchase .answer {
		padding: 30px;
		background: #ffffe8;
		border-radius: 10px;
	}

	#font_purchase .prime_cv-btn {
		position: relative;
		display: inline-block;
		background: gold;
		color: #404040;
		font-size: 18px;
		font-weight: 700;
		width: 300px;
		margin: 0 0 15px;
		padding: 15px 0;
		border-radius: 10px;
		-webkit-transition-duration: .4s;
		transition-duration: .4s;
		border: none;
	}

	#font_purchase .prime_cv-btn span {
		font-size: 12px;
	}

	@media screen and (min-width: 641px) {
		#font_purchase .first-img {
			width: 300px;
		}

		#font_purchase .first-flexright {
			width: calc(100% - 320px);
		}

		#font_purchase .third .feature-item {
			width: 280px;
		}

		#font_purchase .feature-item {
			width: calc(100% / 4 - 5px);
		}

		#font_purchase .sixth {
			margin-bottom: 50px;
		}

		/*20240529*/
		#font_purchase .first-img {
			display: block;
			margin: 0 auto 10px;
		}
	}
</style>

<script>

export default {
	data: function () {
		return {
			fontPaymented:false
		}
	},
	computed: {},
	methods: {
		registYagiprime: function () {
			location.href="/yagiprime_register"
		},
		openFontDialog: function () {
			const app = this
			if (this.$firebase.isAuthenticated) {
				const formData = new FormData()
				formData.append('uuid', this.$firebase.user.uid)

				this.$axios
					.post(this.$varuna.endPoints.getFontpayment, formData, { timeout: 60000 })
					.then(function (response) {
						if (response.data.payment_flag == '1') {
							app.$message({
								message: 'すでに購入済みです。ご利用ください。',
								type: 'warning'
							})
						} else {
							app.$eventHub.$emit('open-fontpayment-dialog', 'lp')
						}
					})
					.catch(function (error) {
					}).finally(function () {
					})

			} else {
				app.$message({
					message: '会員登録が必要です。ログインしてください。',
					type: 'warning'
				})
			}
		},
		getFontpayment: function () {

			this.$nextTick(function () {
				console.error(this.$firebase)
				console.error(this.$firebase.isAuthenticated)
				if (this.$firebase.isAuthenticated) {
					const app = this

					const formData = new FormData()
					formData.append('uuid', this.$firebase.user.uid)

					this.$axios
						.post(this.$varuna.endPoints.getFontpayment, formData, { timeout: 60000 })
						.then(function (response) {
							if (response.data.payment_flag == '1') {
								app.fontPaymented = true
							}
						})
						.catch(function (error) {
						}).finally(function () {
						})

				}
			})
		}
	},
	watch: {},
	created: function () {
		this.getFontpayment()
	},
	mounted: function () { }
}
</script>
